import { FC, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, useIonToast } from '@ionic/react'
import { IonItem, IonLabel, IonRow, IonSpinner, IonText } from '@ionic/react'
import { refresh } from 'ionicons/icons'
import { Admin } from '../../../API'
import { AdminService } from '../../../components/services/AdminService'
import { TbnResponse } from '../../../components/services/TbnResponse'
import { UserService } from '../../../components/services/UserService'
import ImageUpload from '../../../components/util/ImageUpload'
import { failure, success } from '../../../components/util/Toast'
import AdminContainer from '../AdminContainer'

interface OwnProps {}
interface AdminEditProps extends OwnProps {}

const AdminEdit: FC<AdminEditProps> = () => {
  const { sub } = useParams<any>()
  const [user, setUser] = useState<any>()
  const [admin, setAdmin] = useState<Admin>()
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState(false)
  const [present] = useIonToast()

  const addOrEdit = async () => {
    setEditing(true)
    if (!!admin) {
      const res: TbnResponse = await AdminService.Instance.addOrEditAdmin(user?.id, admin)
      if (res.data) success('Success updating admin', present)
      else if (res.errorMessage) failure(res.errorMessage, present)
    }
    setEditing(false)
  }

  const loadUser = async (sub: string) => {
    setLoading(true)
    setUser(undefined)
    setAdmin(undefined)
    const res: TbnResponse | any = await UserService.Instance?.findBySub(sub)
    if (res.data) {
      setUser(res.data)
    } else if (res.errorMessage) {
      failure(res.errorMessage, present)
    }
    setLoading(false)
  }

  const load = async (userID: string) => {
    setLoading(true)
    const res: TbnResponse = await AdminService.Instance.findAdmin(userID)
    if (!!res.data) {
      setAdmin(res.data)
    } else if (res.errorMessage) {
      failure(res.errorMessage, present)
      setAdmin({ userID } as Admin)
    }
    setLoading(false)
  }

  const userDisplay = (user: any) => {
    return user?.phone || user?.email
  }

  const isFormInvalid = () => !admin?.name

  useEffect(() => {
    if (!!admin?.avatar) {
      addOrEdit()
    }
  }, [admin?.avatar]) // eslint-disable-line

  useEffect(() => {
    if (!!sub) {
      loadUser(sub)
    }
  }, [sub]) // eslint-disable-line

  useEffect(() => {
    if (!!user?.id) {
      load(user.id)
    }
  }, [user?.id]) // eslint-disable-line

  return (
    <AdminContainer
      id='adminEdit'
      title={userDisplay(user)}
      actionButtonsEnd={
        <IonButton onClick={() => load(user?.id)}>
          <IonIcon icon={refresh} slot='icon-only' />
        </IonButton>
      }
    >
      <IonGrid>
        <IonRow>
          <IonCol>
            {loading && (
              <div className='ion-text-center'>
                <IonSpinner />
              </div>
            )}
            {!loading && !user?.id && (
              <IonText>
                Admin's user account doesn't exist, Admin need to login and update her/his given name and surname first.
              </IonText>
            )}
          </IonCol>
        </IonRow>
        {!!user && !loading && (
          <>
            <IonRow>
              <IonCol>
                <IonItem>
                  <IonLabel className='required'>Name</IonLabel>
                  <IonInput
                    value={admin?.name}
                    onIonChange={(e: any) => setAdmin({ ...admin, name: e.detail.value } as Admin)}
                    disabled={editing}
                  />
                </IonItem>
                <ImageUpload
                  defaultPath='images/admin/avatar'
                  defaultImage={admin?.avatar}
                  label='Avatar'
                  avatar={true}
                  onTbnChange={(avatar: string) => setAdmin({ ...admin, avatar } as Admin)}
                />
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol className='ion-text-end'>
                <IonButton onClick={addOrEdit} disabled={editing || isFormInvalid()}>
                  Save
                </IonButton>
              </IonCol>
            </IonRow>
          </>
        )}
      </IonGrid>
    </AdminContainer>
  )
}

export default AdminEdit
